export default __webpack_public_path__ + "static/media/logo_microsoft.91be7c64.svg";